import { render, staticRenderFns } from "./DialogAddEditPlayerLive.vue?vue&type=template&id=00422544&scoped=true"
import script from "./DialogAddEditPlayerLive.js?vue&type=script&lang=js&external"
export * from "./DialogAddEditPlayerLive.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00422544",
  null
  
)

export default component.exports